<!-- eslint-disable vue/no-textarea-mustache  -->
<template>
  <div class="speak-enabled-field">
    <textarea :id="id" class="v-rich-text-editor js-speak" v-model="v_model" :rows="rows" :ref="'container'" :name="name">
      {{ currentValue }} 
    </textarea>
    <i class="fa-light fa-microphone speak-mic-btn js-tooltip" title="click_to_tts" :id="spickBtnId"> </i>
    <span class="rec-stop-btn" style="display: none" :id="stopBtnId"></span>
  </div>
</template>
<!-- eslint-enabled vue/no-textarea-mustache -->
<script>
import customTextDecoded from './richEditorCustomComponents/customTextDecoded';
import apiConnector from '@/epersonam/apiConnector';
import Vue from 'vue';

export default {
  name: 'richTextEditor',
  props: ['rows', 'attribute', 'toolbar', 'model', 'otherClass', 'name', 'value', 'blockedComponents', 'disabled'],
  data() {
    return {
      toolbar_elems: [],
      customComponents: [customTextDecoded],
      currentValue: '',
      id: this.uuid(),
    };
  },
  computed: {
    v_model() {
      return this.model ? this.model[this.attribute] : this.model;
    },
    spickBtnId() {
      return `speak-mic-btn-${this.id}`;
    },
    stopBtnId() {
      return `rec-stop-btn-${this.id}`;
    },
  },
  mounted() {
    if (this.value) this.currentValue = this.value;
    this.toolbar_elems = this.toolbar || [];
    var simditor_plugin = window.enabled_copy_and_paste !== 'true',
      modal = $('.modal');
    /// CASO MODAL ///
    modal.on('shown', (ev) => {
      var content = this,
        elements;
      if ($(ev.target).find('.tab-pane').length <= 0 || simditor_plugin) {
        // Modal al cui interno non sono presenti pannelli
        elements = $(ev.target).find('.v-rich-text-editor');
      } else {
        // Modal al cui interno sono presenti tabs => attivo solo le textaree del tab attivo
        elements = $(ev.target).find('.tab-pane[class~="active"]').find('.v-rich-text-editor');
      }
      elements.each(function () {
        if (this === content.$refs.container) {
          content.initialize();
        }
      });
    });
    // END CASO MODAL//
    modal.on('hidden', (ev) => {
      var content = this;
      $(ev.target)
        .find('.v-rich-text-editor')
        .each(function () {
          if (this === content.$refs.container) {
            content.destroy();
          }
        });
    });
    if (simditor_plugin) {
      this.initialize();
    } else {
      /// JHTMLAREA CASO TAB ///
      $('a[data-toggle="tab"]').on('shown', (e) => {
        /// Attivo la textarea solo se il contenitore di quest'ultima è attivo
        if ($(this.$refs.container).parents($(e.target).attr('href')).length > 0 && $(this.$refs.container).parent().is(':visible')) {
          this.initialize();
        }
      });
      if ($(this.$refs.container).is(':visible')) {
        this.initialize();
      }
    }
    const formContainer = $(this.$el).parents('form')[0];
    if (formContainer) {
      setTimeout(function () {
        eventBus.$emit('form-changed-neatly', { id: formContainer.id });
      }, 500);
    }
    window.SpeechRecognizer.init();
    eventBus.$on('SpeechRecognizedReload' + this.id, (val) => {
      // eslint-disable-next-line vue/no-mutating-props
      this.model[this.attribute] = val;
      this.initialize();
    });
  },
  methods: {
    uuid() {
      return Math.random().toString(36).substring(2) + Date.now().toString(36);
    },
    initialize() {
      var simditor_plugin = window.enabled_copy_and_paste !== 'true',
        element = $(this.$refs.container),
        val = $(this.$refs.container).val(); //model[this.attribute]
      if (this.model && this.model[this.attribute] !== undefined) {
        val = this.model[this.attribute];
      } else {
        val = this.currentValue;
      }
      element.addClass(this.otherClass);
      if (simditor_plugin) {
        var el, rows;
        window.Simditor.locale = window.locale == 'it' ? 'it-IT' : 'en-US'; // seems there's no french
        rows = this.rows;
        el = new window.Simditor({
          textarea: element,
          toolbar: [
            'title',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'fontScale',
            'color',
            'ol',
            'ul',
            'table',
            'hr',
            'alignment',
            'link',
            'indent',
            'outdent',
            'code',
            ...this.toolbar_elems,
          ],
          cleanPaste: false,
          toolbarFloat: false,
        });
        el.body.css('min-height', rows + 'em');
        el.setValue(val);
        element.on('change'),
          () => {
            el.setValue(el.textarea.val());
          };
        eventBus.$emit('init-rich-text-editor', { element: el, id: this.id });
        el.on('valuechanged', () => {
          if (this.model) {
            // eslint-disable-next-line vue/no-mutating-props
            this.model[this.attribute] = el.getValue();
          } else {
            this.currentValue = el.getValue();
          }
        });
        this.customComponents.forEach((element) => {
          if (this.blockedComponents && this.blockedComponents.find((term) => term === element.name)) return;

          const ComponentClass = Vue.extend(element);
          const instance = new ComponentClass();
          instance.$mount();
          $(this.$refs.container).siblings('.simditor-toolbar').children(':first').append(instance.$refs.container);
          instance.$on('addTextEvent', (e) => $(this.$refs.container).siblings('.simditor-body').append(e));
          instance.$on('openDecodesEvent', () => this.openDecodes());
        });
      } else {
        element.on('change', () => {
          if (this.model) {
            // eslint-disable-next-line vue/no-mutating-props
            this.model[this.attribute] = element.val();
          } else {
            this.currentValue = el.getValue();
          }
        });
        element.htmlarea({
          css: 'https://s3-eu-west-1.amazonaws.com/epersonam/jHtmlAreaCustom.css',
          toolbar: [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            '|',
            'forecolor',
            '|',
            'unorderedlist',
            'orderedlist',
            '|',
            'indent',
            'outdent',
            '|',
            'justifyleft',
            'justifycenter',
            'justifyright',
          ],
        });
        element.val(val).htmlarea('updateHtmlArea');
      }
    },
    openDecodes(modal) {
      $('.modal').modal('hide');
      Loader.show();
      apiConnector()
        .get(`/${window.locale}/decodes_configs.js?business_unit_id=${window.config.business_unit.id}&cod=custom_text_decoded&key=generale`)
        .then((res) => {
          eval(res.data);
        });
    },
    destroy() {
      if (window.enabled_copy_and_paste !== 'true') {
        var el;
        el = new window.Simditor({
          textarea: $(this.$refs.container),
        });
        return el.destroy();
      }
    },
  },
};
</script>

<style lang="scss">
div.jHtmlArea {
  width: 100% !important;
}

div.jHtmlArea iframe {
  width: 100% !important;
  min-height: 100px !important;
}

div.ToolBar {
  width: 100% !important;
}
</style>
